import prod from '../config/prod';

export const API_BASE_URL =
  process.env.REACT_APP_ICL_API_BASE_URL || `${prod.SERVER}/api/icl-vault`;

export function sphericalEquivalent(sphere, cylinder) {
  return sphere + cylinder / 2;
}

export function roundToHalf(value) {
  return Math.round(value * 2) / 2;
}

export function suggestedOrderSphere(ageYears, opmrSphere, opmrCylinder) {
  const opmrSe = sphericalEquivalent(opmrSphere, opmrCylinder);

  if (ageYears < 30) {
    const suggestedSe = opmrSe + 0.35;
    return {
      sphere: roundToHalf(suggestedSe - opmrCylinder / 2),
      note: '20대: OPMR SE에서 +0.3~0.4D 원시 방향 확인'
    };
  }

  if (ageYears >= 37) {
    return {
      sphere: roundToHalf(opmrSphere),
      note: '30대 후반/40대: OPMR 기준 유지, 마이너스 과교정 회피'
    };
  }

  return {
    sphere: roundToHalf(opmrSphere),
    note: '중간 연령대: OPMR 기준값 우선 확인'
  };
}

export function numeric(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

async function postJson(path, body) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = `요청 처리 중 오류가 발생했습니다. (${response.status})`;

    try {
      const errorBody = JSON.parse(errorText);
      errorMessage = errorBody.message || errorBody.error || errorMessage;
    } catch (error) {
      if (errorText) {
        errorMessage = errorText;
      }
    }

    throw new Error(errorMessage);
  }

  return response.json();
}

export function predictVault(patient, lens) {
  return postJson('/predict', { patient, lens });
}

export function recommendLens(patient) {
  return postJson('/recommend', { patient });
}

export function compareSizes(patient, lens) {
  return postJson('/compare-sizes', {
    patient,
    sphere: lens.sphere,
    cylinder: lens.cylinder
  });
}

export function fetchSimilarCases(patient, topK = 5) {
  return postJson('/similar-cases', {
    patient,
    top_k: topK
  });
}

/**
 * 동일 병원에서 저장된 렌즈 추천 실행 이력을 차트번호와 기간으로 조회한다.
 */
export function fetchLensExamHistory({
  chartNo,
  hospitalId,
  startDt,
  endDt,
  actionType,
  caseId,
  chartNoLike
}) {
  const body = {
    chart_no: chartNo,
    hospital_id: hospitalId,
    startDt,
    endDt
  };
  if (actionType) body.action_type = actionType;
  if (caseId) body.case_id = caseId;
  if (chartNoLike) body.chart_no_like = true;
  return postJson('/exam-history', body);
}

/**
 * 단건 실행 이력의 상세(추천 결과/사이즈 비교/유사 케이스)를 조회한다.
 */
export function fetchLensExamDetail({ examId, hospitalId }) {
  return postJson('/exam-detail', {
    seq_no: examId,
    hospital_id: hospitalId
  });
}

export function saveLensRecommendResult(saveData) {
  return postJson('/save-result', saveData);
}

/**
 * 동일 병원·case_id(없으면 chart+eye) 의 추천/팔로우 이력을 삭제한다.
 */
export function deleteLensPatientRecords({ caseId, chartNo, eye, hospitalId }) {
  return postJson('/delete-patient', {
    case_id: caseId || undefined,
    chart_no: chartNo,
    eye,
    hospital_id: hospitalId
  });
}
